import {
  $Resource,
  $HttpOk,
  $HttpUnauthorized,
  $HttpUnprocessableEntity,
  $HttpHeaders,
} from '@flowio/api-sdk';

export type AuthorizationsPostPaymentAndDetailsAndAdyenByKeyResponse = $HttpOk<
io.flow.payment.v0.unions.Authorization
>
| $HttpUnauthorized<undefined>
| $HttpUnprocessableEntity<io.flow.error.v0.models.GenericError>;

export interface AuthorizationsPostPaymentAndDetailsAndAdyenByKeyParameters {
  body: io.flow.internal.v0.models.AdyenPaymentDetailsForm;
  headers?: $HttpHeaders;
  organization: string;
  key: string;
}

export default class SdkAuthorizationsResource extends $Resource {
  public postPaymentAndDetailsAndAdyenByKey(
    params: AuthorizationsPostPaymentAndDetailsAndAdyenByKeyParameters,
  ): Promise<AuthorizationsPostPaymentAndDetailsAndAdyenByKeyResponse> {
    return this.client.request({
      body: params.body,
      endpoint: `/${encodeURIComponent(params.organization)}/authorizations/${encodeURIComponent(params.key)}/payment/details/adyen`,
      headers: params.headers,
      method: 'POST',
    });
  }
}
